// extracted by mini-css-extract-plugin
module.exports = {"Interstitial":"NPOigTjyRrDjTefCoAwpgw==","Interstitial__Container":"ktODisHOeez1nU8qBRiamw=="};